import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { css } from "@emotion/css";

export default function PostCardCategories({ categories }) {
  // Получаем все категории блога
  const data = useStaticQuery(graphql`
    query {
      allBlogCategory(filter: { wp_parent: { eq: 0 } }) {
        edges {
          node {
            name
            wp_id
            wp_parent
          }
        }
      }
    }
  `);

  // Добавляем запятую
  const categoriesStyle = css`
    span:not(:last-child)::after {
      margin-right: 4px;
      margin-left: 1px;
      content: ",";
    }
  `;

  // Убираем лишнее
  const filteredCategories = data.allBlogCategory.edges.filter(
    (category) => categories.includes(Number(category.node.wp_id)) && category.node.name !== "Library",
  );

  const displayCategories = filteredCategories.length > 0 ? filteredCategories : [{ node: { name: categories[0], wp_id: '1' } }];


  return (
    <div className={categoriesStyle + ` mb-2`}>
      {displayCategories.map((category) => (
        <span
          key={category.node.wp_id}
          className="d-inline-block lightgrey-text text-uppercase font14px"
          dangerouslySetInnerHTML={{ __html: category.node.name }}
        />
      ))}
    </div>
  );
}
